import React, { ComponentProps, memo, useRef } from 'react'

import { useBodyScrollLock } from '@surglogs-app/hooks'
import { Box, LayerManager } from '@surglogs-app/ui'

export const DialogBackground = memo(
  ({ children, ...rest }: ComponentProps<typeof Box>) => {
    const ref = useRef<HTMLDivElement>(null)
    useBodyScrollLock(ref)

    return (
      <LayerManager>
        {({ zIndex, increaseBy }) => (
          <Box
            {...{
              ref,
              zi: 1 + zIndex + increaseBy,
              position: 'fixed',
              top: '0',
              left: '0',
              w: '100%',
              h: '100%',
              bgc: 'white.100',
              overflow: 'hidden',
              ...rest,
            }}>
            {children}
          </Box>
        )}
      </LayerManager>
    )
  },
)
